export default function PrivacyPolicy() {
    return (
        <div className="ae-page-container ae-privacy-policy-page -fade-in">
            <h1>Privacy Policy</h1>
            <p>
                At <b>ActEd.</b> (“we,” “our,” or “us”), we are committed to protecting and respecting your privacy.
                This Privacy Policy explains how we collect, use, and protect your personal data in accordance with the UK General Data Protection Regulation (UK GDPR) and the EU General Data Protection Regulation (EU GDPR).<br></br><br></br>

                By using our website or submitting a contact form, you agree to this policy.

                <h3>1. Who We Are</h3>

                ActEd is the data controller for the personal information collected through this website.<br></br>

                If you have any questions about this Privacy Policy or how we handle your data, please <a className="ae-link b" href="/get-in-touch">get in touch →</a>

                <h3>2. What Information We Collect</h3>

                We collect only the information you choose to provide through our Contact Us form:
                <ul className="ae-privacy-policy-list">
                    <li>Your name</li>
                    <li>Your email address</li>
                    <li>The content of your message or inquiry</li>
                </ul>
                We do not collect any payment, login, or account-related information.<br></br><br></br>

                We may also collect limited technical information automatically through our website (e.g., IP address, browser type, pages visited) for security and analytics purposes. This data is processed in a way that does not directly identify you.

                <h3>3. Legal Basis for Processing</h3>

                Under GDPR, we process your personal data based on one or more of the following legal bases:
                <ul className="ae-privacy-policy-list">
                    <li>Consent: When you voluntarily submit your details via our contact form.</li>
                    <li>Legitimate interests: To respond to inquiries and improve our services.</li>
                    <li>Legal obligation: If required to comply with applicable laws or regulations.</li>
                </ul>
                You may withdraw your consent at any time by <a className="ae-link b" href="/get-in-touch">getting in touch →</a>

                <h3>4. How We Use Your Information</h3>

                We use your information only for the following purposes:
                <ul className="ae-privacy-policy-list">
                    <li>To respond to your inquiry or request for information</li>
                     <li>To maintain internal records of communications</li>
                    <li>To improve our website and user experience</li>
                </ul>
                
                We do not use your information for marketing purposes unless you have explicitly opted in.

                <h3>5. Data Sharing and Transfers</h3>

                We do not sell or rent your personal information.<br></br>
                We may share it only:
                <ul className="ae-privacy-policy-list">
                    <li>With trusted service providers (such as website hosting or email delivery providers) who process data on our behalf and under strict confidentiality agreements.</li>
                    <li>When required by law, regulation, or legal process.</li>
                    <li>If data is transferred outside the UK or EU, we ensure appropriate safeguards (such as Standard Contractual Clauses) are in place to protect your information.</li>
                </ul>
                
               <h3>6. Data Retention</h3> 

                We keep your personal data only as long as necessary to:
                <ul className="ae-privacy-policy-list">
                    <li>Respond to your inquiry, and</li>
                    <li>Comply with any legal or regulatory requirements.</li>
                </ul>
                
                After this period, your personal data will be securely deleted.

                <h3>7. Your Data Protection Rights</h3>

                Under the GDPR, you have the following rights:

                <ul className="ae-privacy-policy-list">
                    <li>Access – to request a copy of the personal data we hold about you</li>
                    <li>Rectification – to request correction of any inaccurate or incomplete information</li>
                    <li>Erasure (“Right to be Forgotten”) – to request deletion of your personal data</li>
                    <li>Restriction of Processing – to request that we limit how we use your data</li>
                    <li>Data Portability – to receive your data in a structured, commonly used format</li>
                    <li>Objection – to object to processing based on legitimate interests</li>
                    <li>Withdraw Consent – to withdraw your consent at any time</li>
                </ul>

                To exercise these rights, please <a className="ae-link b" href="/get-in-touch">get in touch →</a><br></br>
                We will respond within one month as required by law.<br></br><br></br>

                If you believe your data has been mishandled, you have the right to lodge a complaint with your local data protection authority.<br></br><br></br>

                <b>UK: </b><a className="ae-privacy-policy-link" href="https://ico.org.uk/" target="blank" rel="noreferrer">Information Commissioner’s Office (ICO)</a><br></br>

                <b>EU: </b> <a className="ae-privacy-policy-link" href="https://edpb.europa.eu/about-edpb/board/members_en" target="blank" rel="noreferrer">Contact your national supervisory authority</a>

                <h3>8. Cookies and Analytics</h3>

                Our website may use cookies or analytics tools to collect non-personal information about usage patterns and improve functionality.
                You can control or disable cookies through your browser settings.

                <h3>9. Data Security</h3>

                We take appropriate technical and organisational measures to protect your personal data from loss, misuse, or unauthorised access. However, please note that no online system is completely secure.

                <h3>10. Links to Other Websites</h3>

                Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of these external websites.

                <h3>11. Updates to This Policy</h3>

                We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Updates will be posted on this page with an updated “Last Updated” date.

                <h3>Contact Us</h3>
                If you have any questions or wish to exercise your data protection rights, please <a className="ae-link b" href="/get-in-touch">get in touch →</a>
            </p>
        </div>
    )
}